var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import * as React from 'react';
import { getShape, getColor, getBackgroundColor, getBorderColor } from '../util';
const SvgCameraFeedbackAlert = _a => {
  var {
      size,
      shape = 'circle',
      neutral = false
    } = _a,
    props = __rest(_a, ["size", "shape", "neutral"]);
  const backgroundColor = getBackgroundColor(shape, neutral);
  const color = getColor(shape, neutral);
  const borderColor = getBorderColor(neutral);
  return React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: size !== null && size !== void 0 ? size : 96,
    height: size !== null && size !== void 0 ? size : 96,
    fill: "none",
    viewBox: "0 0 96 96"
  }, props), getShape(shape, backgroundColor), React.createElement("path", {
    fill: "var(--color-neutral-70)",
    fillRule: "evenodd",
    d: "m75.977 33.127 1.98 14.09 1.816 12.924c.769 5.469-3.042 10.525-8.51 11.294l-50.874 7.15c-3.835.539-7.378-2.182-7.922-6.057l-4.2-29.885c-.547-3.889 2.124-7.469 5.945-8.006l10.808-1.519a1.876 1.876 0 0 0 1.338-.867l3.876-7.2a5.36 5.36 0 0 1 3.803-2.476l11.636-1.635a5.38 5.38 0 0 1 4.338 1.332l5.71 5.852c.415.377.974.543 1.526.465l10.808-1.519c3.834-.539 7.377 2.182 7.922 6.057Zm-28.115-6.043c-.658-.777-1.502-1.16-2.33-1.044l-9.94 1.397c-.828.116-1.534.718-1.952 1.646l-.82 2.94 16.626-2.337-1.584-2.602Zm17.873 10.253 2.14-.3c1.288-.181 2.189-1.395 2.005-2.7-.183-1.305-1.384-2.223-2.67-2.042l-2.141.301c-1.287.181-2.188 1.394-2.005 2.7.184 1.304 1.384 2.222 2.671 2.041Z",
    clipRule: "evenodd"
  }), React.createElement("path", {
    stroke: borderColor,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "m78.168 48.848-2.191-15.72c-.545-3.876-4.088-6.597-7.922-6.058l-10.808 1.52a1.875 1.875 0 0 1-1.525-.465l-5.71-5.852a5.379 5.379 0 0 0-4.34-1.333l-11.635 1.636a5.359 5.359 0 0 0-3.803 2.476l-3.876 7.2c-.295.475-.786.789-1.338.866l-10.808 1.52c-3.821.536-6.492 4.117-5.945 8.006l4.2 29.884c.544 3.875 4.087 6.596 7.922 6.057l44.243-6.212"
  }), React.createElement("path", {
    fill: color,
    fillRule: "evenodd",
    d: "M28.21 54.194c-1.25-8.896 4.84-17.113 13.626-18.348 8.786-1.234 16.918 4.983 18.155 13.881 1.25 8.896-4.84 17.113-13.626 18.348-8.772 1.233-16.902-4.972-18.154-13.881Zm26.864-5.04c1.561 6.147-2.084 12.394-8.142 13.953-6.059 1.56-12.236-2.16-13.798-8.306-1.562-6.147 2.083-12.394 8.142-13.953 6.058-1.56 12.236 2.16 13.798 8.306Z",
    clipRule: "evenodd"
  }), React.createElement("path", {
    fill: borderColor,
    d: "m59.99 49.727-.742.104.743-.104Zm-13.058 13.38-.187-.726.187.726Zm-13.798-8.306-.727.184.727-.184Zm8.598-19.697c-9.206 1.294-15.57 9.898-14.264 19.194l1.485-.209c-1.194-8.496 4.622-16.324 12.988-17.5l-.21-1.485Zm19.002 14.52c-1.293-9.3-9.797-15.814-19.002-14.52l.209 1.485c8.366-1.176 16.126 4.746 17.307 13.242l1.486-.207ZM46.47 68.817c9.206-1.293 15.57-9.898 14.264-19.194l-1.486.209c1.194 8.496-4.622 16.324-12.987 17.5l.209 1.485ZM27.468 54.298c1.308 9.31 9.81 15.811 19.002 14.52l-.209-1.486c-8.353 1.174-16.112-4.734-17.308-13.243l-1.485.21Zm19.65 9.535c6.469-1.664 10.344-8.326 8.682-14.864l-1.453.37c1.462 5.755-1.953 11.588-7.602 13.042l.373 1.452Zm-14.711-8.848c1.661 6.54 8.242 10.514 14.712 8.848l-.374-1.452c-5.648 1.453-11.422-2.011-12.884-7.765l-1.454.37Zm8.682-14.864c-6.468 1.665-10.343 8.326-8.682 14.864l1.454-.369c-1.463-5.755 1.953-11.588 7.602-13.042l-.374-1.453ZM55.8 48.97c-1.662-6.54-8.242-10.513-14.712-8.848l.374 1.453c5.647-1.453 11.422 2.011 12.884 7.765l1.453-.37Z"
  }), React.createElement("path", {
    stroke: borderColor,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M46.93 63.106c6.06-1.56 9.705-7.806 8.143-13.953-1.562-6.147-7.74-9.865-13.798-8.306-6.058 1.559-9.704 7.806-8.142 13.953 1.562 6.146 7.74 9.865 13.798 8.306ZM47.862 27.084c-.658-.776-1.502-1.16-2.33-1.044l-9.94 1.397c-.828.116-1.534.718-1.952 1.646l-.82 2.94 16.626-2.337-1.584-2.602ZM67.876 37.036l-2.14.3c-1.288.181-2.488-.736-2.672-2.041-.183-1.306.718-2.519 2.005-2.7l2.14-.3c1.287-.181 2.488.736 2.671 2.042.183 1.305-.717 2.518-2.004 2.699Z"
  }), React.createElement("path", {
    fill: color,
    stroke: borderColor,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "m62.148 63.202 14.659-9.326c1.56-1.083 3.726-.073 3.9 1.819l2.278 17.223c.173 1.892-1.778 3.246-3.511 2.438l-16.937-7.898c-1.733-.808-1.949-3.173-.389-4.256Z"
  }), React.createElement("path", {
    fill: "var(--color-neutral-70)",
    fillRule: "evenodd",
    d: "M77.685 59.237c.388.181.476.624.302.92l-2.335 3.844c-.215.36-.61.4-.901.264l-.562-.262c-.213-.1-.446-.409-.31-.829l1.386-4.286c.07-.227.467-.573.986-.32l1.434.67Zm-4.997 8.73a1.508 1.508 0 1 1 1.274-2.734 1.508 1.508 0 0 1-1.274 2.733Z",
    clipRule: "evenodd"
  }));
};
export default SvgCameraFeedbackAlert;